import * as React from "react";
import { Label as LabelPrimitive } from "radix-ui";

import { Label as ShadcnLabel } from "src/shadcn/components/label";

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentProps<typeof LabelPrimitive.Root>
>((props, ref) => <ShadcnLabel ref={ref} {...props} />);

Label.displayName = "Label";

export { Label };
